import axios from 'axios';
import { API_URL } from '../config';

export const getSubscriptions = async (token: string) => {
    const response = await axios.get(`${API_URL}/subscriptions/`,
    {
        headers: {
            'Authorization': `${token}`,
        },
    });
    return response.data;
};

export const getSubscriptionCompany = async (token: string, id: number) => {
    const response = await axios.get(`${API_URL}/subscriptions/${id}/`, {
        headers: {
            'Authorization': token,
        }
    });
    return response.data;
};

export const updateSubscription = async (token: string, id: number, quantity: number) => {
    const response = await axios.patch(`${API_URL}/subscriptions/${id}/`, 
    {
        quantity: quantity,
    }, 
    {
        headers: {
            'Authorization': token,
        }
    });
    return response.data;
};

export const upgradeSubscription = async (token: string, id: number, planCode: string, packagePriceId?: string | null) => {
    const payload: any = {
        plan_code: planCode,
    };

    if (packagePriceId) {
        payload.package_pk = packagePriceId;
    }

    const response = await axios.put(`${API_URL}/subscriptions/${id}/upgrade`,
        payload,
        {
            headers: {
                Authorization: token,
            },
        }
    );

    return response.data;
};

export const deleteSubscription = async (token: string, id: number) => {
    const response = await axios.delete(`${API_URL}/subscriptions/${id}/`,
    {
        headers: {
        'Authorization': `${token}`,
        },
    });
    return response.data;
};


export const addPackageToSubscription = async (token: string, packageId: string) => {
    const response = await axios.post(`${API_URL}/packages/`, 
    {
        package_pk: packageId,
    }, 
    {
        headers: {
            'Authorization': token,
        }
    });
    return response.data;
};

export const validateSubscriptionCoupon = async (
    token: string,
    {
        coupon,
        planPriceId,
        quantity = 1,
        packagePriceId = null,
    }: {
        coupon: string;
        planPriceId: string;
        quantity?: number;
        packagePriceId?: string | null;
    }
) => {
    const payload: {
        coupon: string;
        plan_price_id: string;
        quantity: number;
        package_price_id?: string;
    } = {
        coupon,
        plan_price_id: planPriceId,
        quantity,
    };

    if (packagePriceId) {
        payload.package_price_id = packagePriceId;
    }

    const response = await axios.post(
        `${API_URL}/subscriptions/validate-coupon/`,
        payload,
        {
            headers: {
                'Authorization': token,
            },
        }
    );

    return response.data;
};

